import ProjectList from "./ProjectList";
import ProjectIcon from "@mui/icons-material/Create";
import ProjectShow from "./ProjectShow";

const ProjectResourceProps = {
    name: "project",
    list: ProjectList,
    show: ProjectShow
};

export const ProjectMenuProps = {
    to: "/project",
    primaryText: "Projets",
    icon: ProjectIcon
};

export default ProjectResourceProps;
